import * as React from 'react';
const SvgMinus = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 7.857h20v4.286H0z" />
  </svg>
);
export default SvgMinus;
